export default __webpack_public_path__ + "static/media/ic_next_arrow.853deaa3.svg";